<template>
  <div class="animated fadeIn">
    <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Delivey Management<small class="text-muted"> upload orders</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">

              </div><!--col-->
          </div><!--row-->
          <hr />
          <form>
            <div class="form-group row">
              <label for="inputCourierName" class="col-sm-2 col-form-label">Courier Service Name</label>
              <div class="col-sm-6">
                <select class="form-control" v-model="selectedServiceCode" @change="this.onChangeCourierService">
                  <option value="">-- {{ $t('general.input.please_select_courier_service') }} --</option>
                  <option v-for="(courierService, index) in courierServices" :value="courierService.service_code" :key="index">
                    {{ courierService.service_code }} - {{ courierService.internal_name }}
                  </option>
                </select>
              </div>
            </div>
             <div v-if='selectedCourierService && selectedCourierService.courier_platform_service_code' class="form-group row">
              <label for="inputCourierName" class="col-sm-2 col-form-label">Shipping Method</label>
              <div class="col-sm-6">
                {{ selectedCourierService.courier_platform_service_code }}
              </div>
            </div>
            <div v-if='selectedCourierService && selectedCourierService.delivery_shipper' class="form-group row" >
              <label for="inputCourierName" class="col-sm-2 col-form-label">Shipper Account</label>
              <div class="col-sm-6">
                {{ selectedCourierService.delivery_shipper.shipper_name }}
              </div>
            </div>
            <div class="form-group row" style="display:none">
              <label for="biz_type" class="col-sm-2 col-form-label">Shipper Account</label>
              <div class="col-sm-6">
                <select class="form-control" v-model="selectedBizType">
                  <option value="api">API</option>
                  <!-- <option value="manual">Manual</option> -->
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="costFile" class="col-sm-2 col-form-label">Orders File</label>
              <div class="col-sm-8">
                <label class="file">
                  <input type="file" name="file" id="file" @change="fileChange($event.target.name, $event.target.files)">
                  <span class="file-custom"></span>
                </label>
                <small id="costFile" class="form-text text-danger">
                  Click <a href="https://oms.lme-ecom.com/download/deliveryOrderTemplate.xlsx" class="font-weight-bold" target="_blank"> HERE </a> to get cost tempalte
                </small>
              </div>
            </div>
            <div slot="footer">
              <b-button type="submit" size="sm" @click.stop.prevent="handleUpload" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            </div>
           </form>
        </b-card>
      </div>
    </div>
    <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>

<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'UploadDeliveryOrders',
  beforeCreate () {
    this.axios.get('delivery/upload/order').then(response => {
      if (response.data) {
        this.courierServices = response.data
      }
    }).catch(error => {
      console.log(error)
    })
  },
  components: {
    loadingPanel
  },
  data () {
    return {
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      file: '',
      courierServices: [],
      selectedBizType: 'api',
      selectedServiceCode: '',
      selectedCourierService: {},
      formData: new FormData()
    }
  },
  methods: {
    fileChange (fileName, fileList) {
      if (!fileList.length) {
        return
      }
      this.formData.append(fileName, fileList[0], fileList[0].name)
    },
    onChangeCourierService (){
      this.selectedCourierService = null
      this.courierServices.map((item) => {
        if(item.service_code == this.selectedServiceCode){
          this.selectedCourierService = item
          if (item.shipper_name === undefined || item.shipper_name  === null ) {
            this.$swal({
              title: 'You have not set shipper Account',
              text: 'Please contact LME IT to create shipper account First!',
              icon: 'warning',
              animation: false,
              customClass: 'animated tada'
            })
          }
        }
      })
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    handleUpload () {
      var config = {
        onUploadProgress: function () {
          // var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
        }
      }
      this.formData.append('service_code', this.selectedServiceCode)
      this.formData.append('biz_type', this.selectedBizType)
      this.showLoadingPanel = true
      this.axios.post('delivery/upload/order', this.formData, config)
        .then(() => {
          this.showLoadingPanel = false
          this.$router.push('/delivery/pending')
        })
        .catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
    }
  }
}
</script>
